export const OOOStatus = {
    0: 'Disabled',
    1: 'AlwaysEnabled',
    2: 'Scheduled'
}